window.addEventListener("DOMContentLoaded", () => {
  const viewport = document.querySelector('meta[name="viewport"]');
  function adjustViewport() {
    const viewportBreakpoint = 374;
    const value =
      window.outerWidth > viewportBreakpoint
        ? "width=device-width, initial-scale=1.0"
        : `width=${viewportBreakpoint}`;
    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }
  window.addEventListener("resize", adjustViewport, false);
});
